import { createFileRoute } from '@tanstack/react-router'
import { ModulesPage } from '@/features/classes'

export const Route = createFileRoute('/_authenticated/classes/')({
  component: ModulesPage,
})
